<template lang="pug">
  div#app
    Toast
    router-view
</template>

<script>
import '@/utils/cookie'
import util from '@/utils'
import Toast from './components/toast.vue'

export default {
  name: 'App',
  components: {
    Toast,
  },
  created() {
    // 判断是否www.amuletj.com网页
    this.judgeRouter()
  },
  beforeUpdate() {
    this.judgeRouter()
  },

  methods: {
    judgeRouter() {
      if (window.location.href.indexOf('www.amuletj.com') > -1) {
      this.$router.replace('/amuletj')
    } else {
      if (this.$route.name === 'wholesale' || this.$route.name === 'wholesale-h5') {
        if (util.isMobile()) {
          this.$router.replace('/wholesale/m')
        } else {
          this.$router.replace('/wholesale')
        }
      } else if (this.$route.name === 'home' || this.$route.name === 'home-h5' || this.$route.name === 'promotion' || this.$route.name === 'promotion-h5') {
        if (util.isMobile()) {
          this.$router.replace('/promotion/m')
        } else {
          this.$router.replace('/promotion')
        }
      }
    }
    }
  },
}
</script>

<style lang="stylus">
// 修改所有页面颜色为黑白
// html{
//   filter: grayscale(100%);
//   -moz-filter: grayscale(100%);
//   -o-filter: grayscale(100%);
//   -webkit-filter: grayscale(1);
// }

*
  margin 0
  padding 0
  position relative
.safe-padding-bottom
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
</style>



// WEBPACK FOOTER //
// src/App.vue